import { createAction, PayloadAction } from "@reduxjs/toolkit";

import { KeysOfType } from "infrastructure";
import { INotification } from "infrastructure/notification";

import { appNotification, appTranslation, settings } from "./app.slice";

import { ILocationChangeActionData } from "./";

const clearScreenNotifications = createAction("CLEAR_SCREEN_NOTIFICATIONS");
const removeScreenNotification = createAction<number>("REMOVE_SCREEN_NOTIFICATION");

export const locationChange = createAction<ILocationChangeActionData>("LOCATION_CHANGE");
export const changeTenant = createAction<string>("CHANGE_TENANT");

export const appNotificationActions = { ...appNotification.actions, clearScreenNotification: clearScreenNotifications, removeScreenNotification };
export const appTranslationActions = { ...appTranslation.actions };
export const settingsActions = { ...settings.actions };

export const getScreenExtraReducers = <TState>(messagesProp: KeysOfType<TState, INotification[]>, initialState: TState) => ({
  [clearScreenNotifications.toString()]: (state: TState) => {
    return { ...state, [messagesProp]: [] };
  },
  [removeScreenNotification.toString()]: (state: TState, action: PayloadAction<number>) => {
    if (state[messagesProp]) {
      const messages: INotification[] = state[messagesProp.toString()];

      messages.splice(action.payload, 1);
    }
    return state;
  },
  [locationChange.toString()]: (_state: TState): TState => {
    return initialState;
  },
  [changeTenant.toString()]: (_state: TState): TState => {
    return initialState;
  }
});
